import { components } from '@feedfm/clips-services-api';

export type SimilarTrack = components['schemas']['SimilarTrack'];
export type SharedVibeTag = components['schemas']['SharedVibeTag'];

export const NOT_SOUND_SHORTCUTS = {
  h: 'holiday',
  c: 'childrens',
  v: 'devotional',
  x: 'explicit',
  w: 'wrong_language',
  l: 'lyrics',
  p: 'not_popular',
  q: 'bad_quality',
  o: 'other',
} as const;

export const SOUND_SHORTCUTS = {
  t: 'tempo',
  s: 'style',
  m: 'mood',
  o: 'other',
} as const;

export const WHICH_SONG_SHORTCUTS = {
  '1': 'original',
  '2': 'similar',
  '0': 'neither',
} as const;

export type WhichSongSelection = 'original' | 'similar' | 'neither';

export type NotSoundReason =
  | 'holiday'
  | 'childrens'
  | 'devotional'
  | 'wrong_language'
  | 'explicit'
  | 'lyrics'
  | 'not_popular'
  | 'bad_quality'
  | 'other';

export type SoundReason = 'tempo' | 'style' | 'mood' | 'other';

export type WhichSongReason =
  | 'holiday'
  | 'childrens'
  | 'wrong_language'
  | 'explicit'
  | 'devotional';

export interface FeedbackDialogState {
  open: boolean;
  trackId: number;
  trackTitle: string;
}

export interface NotSoundReasonDialogState {
  open: boolean;
  otherText: string;
  showOtherInput: boolean;
}

export interface SoundReasonDialogState {
  open: boolean;
  otherText: string;
  showOtherInput: boolean;
}

export interface WhichSongDialogState {
  open: boolean;
  reason: WhichSongReason | null;
}

export interface VibeTracksModalState {
  open: boolean;
  vibeTagId: number;
  vibeTagName: string;
}
